import React, { useState } from "react";
import { Link, } from 'react-router-dom';
import useScrollHeader from './Package/useScrollHeader';

const Navbar = () => {
  const [navActive, setNavActive] = useState(false);
  const headerActive = useScrollHeader();

  const toggleNav = () => {
    setNavActive(!navActive);
  };

  return (
    <>
      <div className="video-background">
        <video autoPlay muted loop id="bg-video">
          <source src="/assets/images/hero-2.mp4" type="video/mp4" />
        </video>
      </div>
      {/* #HEADER */}
      <header className={`header ${headerActive ? 'active' : ''}`} data-header="">
        <div className="container">
          <Link to="/" className="logo">
            {/* <img src="/assets/images/portfolio-logo1.png" width={119} height={37} alt="PrabhSingh.in" /> */}
            <h3 className="span">PRABHSINGH</h3>
          </Link>
          <nav className={`navbar ${navActive ? 'active' : ''}`} data-navbar="">
            <div className="navbar-top">
              <Link to="/" className="logo">
                <img src="/assets/images/portfolio-logo1.png" width="119" height="37" alt="PrabhSingh.in" />
              </Link>
              <button className="nav-close-btn" aria-label="close menu" onClick={toggleNav}>
                <ion-icon name="close-outline" aria-hidden="true" />
              </button>
            </div>
            <ul className="navbar-list">
              <li>
                <Link to="/" className="navbar-link hover-1">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/projects" className="navbar-link hover-1">
                  My Projects
                </Link>
              </li>
              <li>
                <Link to="/socialMedia" className="navbar-link hover-1">
                  Social Links
                </Link>
              </li>
              <li>
                <Link to="/blog" className="navbar-link hover-1">
                  My Blogs
                </Link>
              </li>
              <li>
                <Link to="/contactMe" className="navbar-link hover-1" onClick={toggleNav}>
                  Contact Me
                </Link>
              </li>
            </ul>
          </nav>
          <Link to="#" className="btn btn-primary subs">
            Subscribe
          </Link>
          <button className="nav-open-btn" aria-label="open menu" onClick={toggleNav}>
            <ion-icon name="menu-outline" aria-hidden="true" />
          </button>
        </div>
      </header>
    </>
  );
};

export default Navbar;
